export const special_pre_payment_methods = [
  {
    key: "meal_ticket_finance",
    quantityKey: "meal_ticket_amount",
    label: "Vale Refeição",
  },
  {
    key: "food_ticket_finance",
    quantityKey: "food_ticket_amount",
    label: "Vale Alimentação",
  },
  {
    key: "fuel_ticket_finance",
    quantityKey: "fuel_ticket_amount",
    label: "Vale Combustível",
  },
  {
    key: "vale_outsider_finance",
    quantityKey: "vale_outsider_amount",
    label: "Vale Externo",
  },
  {
    key: "vale_worker_finance",
    quantityKey: "vale_worker_amount",
    label: "Vale Funcionário",
  },
];

export const MENU_WIDTH = "240px";
export const COLLAPSED_DRAWER_WIDTH = 64;
